/* import __COLOCATED_TEMPLATE__ from './finish.hbs'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action } from '@ember/object';
import Component from '@glimmer/component';
let TwoFactorEnrollFinishComponent = (_class = class TwoFactorEnrollFinishComponent extends Component {
  constructor() {
    super(...arguments);
  }
  finish() {
    if (this.args.finish) {
      this.args.finish();
    }
  }
}, _applyDecoratedDescriptor(_class.prototype, "finish", [action], Object.getOwnPropertyDescriptor(_class.prototype, "finish"), _class.prototype), _class);
export { TwoFactorEnrollFinishComponent as default };